// extracted by mini-css-extract-plugin
module.exports = {"regions":"Platforms_regions__2uJ81","add_region_grid":"Platforms_add_region_grid__2SLIc","region_name":"Platforms_region_name__3EwE6","region_item":"Platforms_region_item__1ByyA"};